<!-- Vista compacta de una sola pantalla sin scroll pesado -->
<div class="container-fluid mt-2 px-3" style="font-size: 0.88rem;">
  
  <div class="d-flex justify-content-between align-items-center mb-2 border-bottom pb-1">
    <h2 class="h5 m-0 fw-bold text-dark">Crear Cliente</h2>
    
    <div class="d-flex align-items-center gap-3">
      <!-- Interruptor visual para activar la captura exprés -->
      <div class="form-check form-switch m-0">
        <input class="form-check-input" type="checkbox" id="switchAltaRapida" 
              (change)="toggleAltaRapida($event)" [checked]="altaRapida" style="cursor: pointer;">
        <label class="form-check-label fw-bold text-primary small" for="switchAltaRapida" style="cursor: pointer;">
          ⚡ Alta Rápida (Solo Nombre)
        </label>
      </div>
      <span class="badge bg-primary">Address Book JDE</span>
    </div>
  </div>


  <form [formGroup]="customerForm" (ngSubmit)="addCustomer()">

    <!-- SECCIÓN 1: IDENTIFICACIÓN RAÍZ DE NEGOCIO (AN8 e Identidad Legal) -->
    <div class="card bg-light mb-2 border-0 shadow-sm">
      <div class="card-body p-2">
        <div class="row g-2">
          
          <div class="col-md-3">
            <div class="form-floating">
              <input type="text" class="form-control text-dark" id="an8" formControlName="an8"
                    [ngClass]="{'is-invalid': customerForm.get('an8')?.touched && customerForm.get('an8')?.invalid}"
                    placeholder="Opcional (Next Number)" 
                    maxlength="8"
                    (keypress)="soloNumeros($event)"> <!-- Filtro estricto en Angular -->
              <label for="an8" class="text-secondary">Código AN8 (Dejar vacío para automático)</label>
              <div class="invalid-feedback">Si captura un número manual, debe contener exactamente 8 dígitos numéricos.</div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-floating">
              <!-- 🌟 AGREGADO: [ngClass] para activar el recuadro rojo por discrepancia -->
              <select class="form-select" id="fisicaMoral" formControlName="fisicaMoral"
                    [ngClass]="{'is-invalid': customerForm.get('fisicaMoral')?.touched && customerForm.get('fisicaMoral')?.invalid}">
                <option *ngFor="let tipo of tiposPersona" [value]="tipo.codigo">
                  {{ tipo.descripcion }}
                </option>
              </select>
              <label for="fisicaMoral" class="text-secondary">Régimen Fiscal *</label>
              
              <!-- 🌟 AGREGADO: Mensaje de error para el Régimen Fiscal -->
              <div class="invalid-feedback" *ngIf="customerForm.get('fisicaMoral')?.hasError('rfcRegimenInvalido')">
                Régimen incongruente con la longitud del RFC.
              </div>
            </div>
          </div>

          <div class="col-md-3"> <!-- Asegúrate de conservar la columna envolvente col-md que tenías -->
            <div class="form-floating">
              <input type="text" class="form-control text-uppercase" id="rfc" formControlName="rfc"
                    appUppercase
                    [ngClass]="{'is-invalid': customerForm.get('rfc')?.touched && customerForm.get('rfc')?.invalid}"
                    placeholder="XAXX010101000">
              <label for="rfc" class="text-secondary">RFC Oficial *</label>
              
              <div class="invalid-feedback">
                <span *ngIf="customerForm.get('rfc')?.hasError('required')">El RFC oficial es requerido.</span>
                <span *ngIf="customerForm.get('rfc')?.hasError('pattern')">Ingrese un formato de RFC legal y válido.</span>
                <!-- 🌟 MODIFICADO: Muestra el texto dinámico de la discrepancia -->
                <span *ngIf="customerForm.get('rfc')?.hasError('rfcRegimenInvalido')">
                  {{ customerForm.get('rfc')?.getError('rfcRegimenInvalido') }}
                </span>
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-floating">
              <select class="form-select" id="approvalStatus" formControlName="approvalStatus">
                <option *ngFor="let est of estatusAprobacion" [value]="est">{{ est }}</option>
              </select>
              <label for="approvalStatus" class="text-secondary">Estatus Aprobación</label>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- SECCIÓN 2: DATOS GENERALES Y RAZÓN SOCIAL -->
    <div class="card mb-2 border-0 shadow-sm">
      <div class="card-body p-2">
        
        <div class="row g-2 mb-2">
          <div class="col-md-6">
            <div class="form-floating">
              <input type="text" class="form-control text-uppercase" id="name" formControlName="name" 
                     appUppercase
                     [ngClass]="{'is-invalid': customerForm.get('name')?.touched && customerForm.get('name')?.invalid}"
                     placeholder="Nombre Comercial">
              <label for="name">Nombre Comercial o Razón Social Legal*</label>
              <div class="invalid-feedback">El nombre comercial es requerido.</div>
            </div>
          </div>

<!--           <div class="col-md-6">
            <div class="form-floating">
              <input type="text" class="form-control text-uppercase" id="razonSocial" formControlName="razonSocial"
                     appUppercase
                     [ngClass]="{'is-invalid': customerForm.get('razonSocial')?.touched && customerForm.get('razonSocial')?.invalid}"
                     placeholder="Razón Social">
              <label for="razonSocial">Razón Social Legal *</label>
              <div class="invalid-feedback">La razón social es obligatoria para la facturación.</div>
            </div>
          </div>  -->

        </div>

        <div class="row g-2 mb-2">
          <div class="col-md-4">
            <div class="form-floating">
            <input type="text" class="form-control text-uppercase" id="email" formControlName="email"
                appUppercase
                [ngClass]="{'is-invalid': customerForm.get('email')?.touched && customerForm.get('email')?.invalid}"
                placeholder="correo@empresa.com">
            <label for="email">Correo Electrónico Central *</label>
            
            <div class="invalid-feedback">
              <!-- Mensaje tradicional si lo dejan vacío -->
              <span *ngIf="customerForm.get('email')?.hasError('required')">El correo electrónico es obligatorio para el alta del cliente.</span>
              
              <!-- Mensaje tradicional si el formato está mal escrito -->
              <span *ngIf="customerForm.get('email')?.hasError('email')">Por favor ingrese un formato de correo válido.</span>
              
              <!-- MANTENIDO: El mensaje rojo estático abajo del campo que querías conservar -->
              <span *ngIf="customerForm.get('email')?.hasError('correoDuplicado')" class="fw-bold text-danger">
              ⚠️ Correo ya registrado en el sistema. Pertenece a un cliente existente en la base de datos.
              </span>
            </div>
            </div>
          </div>
          

          <div class="col-md-4">
            <div class="form-floating">
              <!-- Reemplazamos <input> por un <select> reactivo dinámico -->
              <select class="form-select" id="giroEmpresa" formControlName="giroEmpresa">
                <option value="">-- Seleccione Actividad Económica --</option>
                <!-- Iteramos de forma limpia usando las propiedades de tu tabla UDC -->
                <option *ngFor="let g of girosEconomicos" [value]="g.keyRef">
                  {{ g.description }}
                </option>
              </select>
              <label for="giroEmpresa">Giro o Actividad Económica</label>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-floating">
              <input type="text" class="form-control text-uppercase" id="webSite" formControlName="webSite" placeholder="Sitio Web" 
                appUppercase
              >
              <label for="webSite">Sitio Web</label>
            </div>
          </div>
        </div>

        <!-- SECCIÓN 3: LOCALIZACIÓN Y DOMICILIO FISCAL -->
        <div class="border-top my-2 pt-2 text-secondary fw-bold" style="font-size: 0.8rem;">DOMICILIO FISCAL COMPLETO</div>
        
        <!-- FILA 1: Calle, Colonia y Código Postal -->
        <div class="row g-2 mb-2">
          <div class="col-md-5">
            <div class="form-floating">
              <input type="text" class="form-control text-uppercase" id="calleNumero" formControlName="calleNumero"
                     appUppercase
                     [ngClass]="{'is-invalid': customerForm.get('calleNumero')?.touched && customerForm.get('calleNumero')?.invalid}"
                     placeholder="Calle y Número">
              <label for="calleNumero">Calle, Avenida y Número *</label>
              <div class="invalid-feedback">La dirección de calle es obligatoria.</div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-floating">
              <input type="text" class="form-control text-uppercase" id="colonia" formControlName="colonia" 
                     appUppercase
                     [ngClass]="{'is-invalid': customerForm.get('colonia')?.touched && customerForm.get('colonia')?.invalid}"
                     placeholder="Colonia">
              <label for="colonia">Colonia / Fraccionamiento *</label>
              <div class="invalid-feedback">La colonia es requerida.</div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-floating">
              <input type="text" class="form-control" id="codigoPostal" formControlName="codigoPostal"
                     [ngClass]="{'is-invalid': customerForm.get('codigoPostal')?.touched && customerForm.get('codigoPostal')?.invalid}"
                     placeholder="44100" maxlength="5">
              <label for="codigoPostal">Código Postal (5 dígitos) *</label>
              <div class="invalid-feedback">Ingrese un Código Postal numérico válido de 5 dígitos.</div>
            </div>
          </div>
        </div>

        <!-- FILA 2: Municipio, País y Estado -->
        <div class="row g-2 mb-2">
          <div class="col-md-4">
            <div class="form-floating">
              <input type="text" class="form-control text-uppercase" id="delegacionMnicipio" formControlName="delegacionMnicipio"
                     appUppercase
                     [ngClass]="{'is-invalid': customerForm.get('delegacionMnicipio')?.touched && customerForm.get('delegacionMnicipio')?.invalid}"
                     placeholder="Municipio">
              <label for="delegacionMnicipio">Delegación o Municipio *</label>
              <div class="invalid-feedback">El municipio es requerido.</div>
            </div>
          </div>


          <div class="col-md-4">
            <div class="form-floating">
              <!-- Escucha el cambio de país y actualiza el formulario -->
              <select class="form-select" id="country" formControlName="country" (change)="onPaisCambiado($event)">
                <option value="">-- Seleccione País --</option>
                <!-- CORREGIDO: Uso de camelCase exacto de tu entidad Java (keyRef y description) -->
                <option *ngFor="let p of paises" [value]="p.keyRef">
                  {{ p.description }}
                </option>
              </select>
              <label for="country">País / Región *</label>
            </div>
          </div>          

          <!-- SELECTOR / INPUT CONDICIONAL DE ESTADO -->
          <div class="col-md-4">
            <div class="form-floating">
              
              <!-- CASO A: Selector Desplegable (México / USA) -->
              <!-- 🌟 AGREGADO: [ngClass] para activar el recuadro rojo de Bootstrap -->
              <select *ngIf="mostrarDesplegableEstado" class="form-select text-uppercase" id="estadoSelect" formControlName="estado"
                      [ngClass]="{'is-invalid': customerForm.get('estado')?.touched && customerForm.get('estado')?.invalid}">
                <option value="">-- Seleccione Estado / Entidad --</option>
                <option *ngFor="let est of estados" [value]="est.description">
                  {{ est.description }}
                </option>
              </select>

              <!-- CASO B: Caja de Captura Libre (Otros Países) -->
              <!-- 🌟 AGREGADO: [ngClass] para activar el recuadro rojo de Bootstrap -->
              <input *ngIf="!mostrarDesplegableEstado" type="text" class="form-control text-uppercase" id="estadoInput" formControlName="estado"
                    appUppercase
                    [ngClass]="{'is-invalid': customerForm.get('estado')?.touched && customerForm.get('estado')?.invalid}"
                    placeholder="Escriba Provincia o Estado">

              <label for="estadoSelect">Estado / Entidad / Provincia *</label>
              
              <!-- 🌟 AGREGADO: Mensaje visual de error debajo del campo -->
              <div class="invalid-feedback">El estado o provincia es obligatorio para el alta detallada.</div>
            </div>
          </div>
        </div>       

        <!-- FILA 3: Ciudad y Teléfono (Justo antes de teléfono) -->
        <div class="row g-2">
          
          <!-- Nuevo Campo: Ciudad (col-md-6 para dividir la fila a la mitad) -->
          <div class="col-md-6">
            <div class="form-floating">
              <input type="text" class="form-control text-uppercase" id="ciudad" formControlName="ciudad"
                     appUppercase
                     [ngClass]="{'is-invalid': customerForm.get('ciudad')?.touched && customerForm.get('ciudad')?.invalid}"
                     placeholder="Ciudad">
              <label for="ciudad">Ciudad *</label>
              <div class="invalid-feedback">La ciudad es requerida.</div>
            </div>
          </div>

          <!-- Campo: Teléfono de Contacto (col-md-6 para la otra mitad) -->
          <div class="col-md-6">
            <div class="form-floating">
              <!-- Bloqueamos letras físicamente en el teclado con (keypress) -->
              <input type="text" class="form-control" id="telefonoDF" formControlName="telefonoDF"
                    (keypress)="soloNumeros($event)"
                    [ngClass]="{'is-invalid': customerForm.get('telefonoDF')?.touched && customerForm.get('telefonoDF')?.invalid}"
                    placeholder="3312345678">
              <label for="telefonoDF">Teléfono Contacto (Gestor de Flota / Ajustador)</label>
              <!-- Alerta visual dinámica de error -->
              <div class="invalid-feedback">
                El teléfono debe contener exactamente 10 dígitos numéricos para números de México.
              </div>
            </div>
          </div>

        </div>

        <!-- SECCIÓN 4: CONDICIONES COMERCIALES Y DE PAGO -->
<!--         <div class="border-top my-2 pt-2 text-secondary fw-bold" style="font-size: 0.8rem;">PARÁMETROS DE CRÉDITO Y TESORERÍA</div>
        <div class="row g-2"> -->
<!--           <div class="col-md-3">
            <div class="form-floating">
              <select class="form-select" id="paymentMethod" formControlName="paymentMethod">
                <option value="">-- Elige Método --</option>
                <option *ngFor="let mp of metodosPago" [value]="mp">{{ mp }}</option>
              </select>
              <label for="paymentMethod">Método de Pago (SAT)</label>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-floating">
              <select class="form-select" id="formaPago" formControlName="formaPago">
                <option value="">-- Elige Forma --</option>
                <option *ngFor="let fp of formasPago" [value]="fp">{{ fp }}</option>
              </select>
              <label for="formaPago">Forma de Pago (Clave)</label>
            </div>
          </div> -->

<!--           <div class="col-md-2">
            <div class="form-floating">
              <input type="text" class="form-control" id="diasCredito" formControlName="diasCredito" placeholder="0">
              <label for="diasCredito">Días de Crédito</label>
            </div>
          </div> -->

<!--           <div class="col-md-2">
            <div class="form-floating">
              <select class="form-select" id="currencyCode" formControlName="currencyCode">
                <option *ngFor="let moneda of tiposMoneda" [value]="moneda">{{ moneda }}</option>
              </select>
              <label for="currencyCode">Divisa Base</label>
            </div>
          </div> -->

<!--           <div class="col-md-2">
            <div class="form-floating">
              <input type="datetime-local" class="form-control bg-light" id="fechaSolicitud" formControlName="fechaSolicitud" readonly>
              <label for="fechaSolicitud">Fecha de Alta (Sistema)</label>
            </div>
          </div> -->
        <!-- </div> -->

		<!-- SECCIÓN 5: CONTACTOS ADICIONALES OPERATIVOS -->
        <div class="border-top my-2 pt-2 text-secondary fw-bold" style="font-size: 0.8rem; letter-spacing: 0.5px;">
          DIRECTORIO DE CONTACTOS DE NEGOCIO
        </div>
        
        <!-- ROW 1: CUENTAS POR COBRAR (CxC) -->
        <div class="row g-2 mb-2">
          <div class="col-md-4">
            <div class="form-floating">
              <input type="text" class="form-control text-uppercase" id="nombreContactoCxC" formControlName="nombreContactoCxC" 
                appUppercase
                placeholder="Nombre CxC">
              <label for="nombreContactoCxC">Nombre Contacto CxC (Pagos/Facturación de tu cliente)</label>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-floating">
              <input type="text" class="form-control text-uppercase" id="emailContactoCxC" formControlName="emailContactoCxC" 
                appUppercase
                placeholder="Email CxC">
              <label for="emailContactoCxC">Email Contacto CxC</label>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-floating">
              <input type="text" class="form-control" id="telefonoContactoCxC" formControlName="telefonoContactoCxC"
                    (keypress)="soloNumeros($event)"
                    [ngClass]="{'is-invalid': customerForm.get('telefonoContactoCxC')?.touched && customerForm.get('telefonoContactoCxC')?.invalid}"
                    placeholder="3312345678">
              <label for="telefonoContactoCxC">Teléfono Contacto CxC</label>
              <div class="invalid-feedback">Debe contener exactamente 10 dígitos numéricos para México.</div>
            </div>
          </div>          
        </div>

        <!-- ROW 2: REFACTORIZADO A CONTACTO DE OPERACIONES / LOGÍSTICA -->
        <div class="row g-2 mb-2">
          <div class="col-md-4">
            <div class="form-floating">
              <!-- Se mantiene amarrado a tu variable original 'nombreContactoPedidos' -->
              <input type="text" class="form-control text-uppercase" id="nombreContactoPedidos" formControlName="nombreContactoPedidos"                 
                appUppercase
                placeholder="Nombre Operaciones">
              <!-- 💡 CAMBIO DE ETIQUETA SOLICITADO -->
              <label for="nombreContactoPedidos">Contacto de Operaciones/Logística</label>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-floating">
              <input type="text" class="form-control text-uppercase" id="emailContactoPedidos" formControlName="emailContactoPedidos"                 
                appUppercase
                placeholder="Email Operaciones">
              <label for="emailContactoPedidos">Email Operaciones/Logística</label>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-floating">
              <input type="text" class="form-control" id="telefonoContactoPedidos" formControlName="telefonoContactoPedidos"
                    (keypress)="soloNumeros($event)"
                    [ngClass]="{'is-invalid': customerForm.get('telefonoContactoPedidos')?.touched && customerForm.get('telefonoContactoPedidos')?.invalid}"
                    placeholder="3312345678">
              <label for="telefonoContactoPedidos">Teléfono Operaciones/Logística</label>
              <div class="invalid-feedback">Debe contener exactamente 10 dígitos numéricos para México.</div>
            </div>
          </div>          
        </div>

        <!-- ROW 3: 🚀 NUEVA FILA VISIBLE PARA CONTACTO DE VENTAS -->
        <div class="row g-2">
          <div class="col-md-4">
            <div class="form-floating">
              <!-- Mapeado a tu variable original 'nombreContactoVentas' que ya se inserta nativamente -->
              <input type="text" class="form-control text-uppercase" id="nombreContactoVentas" formControlName="nombreContactoVentas"                 
                appUppercase
                placeholder="Nombre Ventas">
              <label for="nombreContactoVentas">Contacto Comercial / Ventas</label>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-floating">
              <input type="text" class="form-control text-uppercase" id="emailContactoVentas" formControlName="emailContactoVentas"                 
                appUppercase
                placeholder="Email Ventas">
              <label for="emailContactoVentas">Email Comercial / Ventas</label>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-floating">
              <input type="text" class="form-control" id="telefonoContactoVentas" formControlName="telefonoContactoVentas"
                    (keypress)="soloNumeros($event)"
                    [ngClass]="{'is-invalid': customerForm.get('telefonoContactoVentas')?.touched && customerForm.get('telefonoContactoVentas')?.invalid}"
                    placeholder="3312345678">
              <label for="telefonoContactoVentas">Teléfono Comercial / Ventas</label>
              <div class="invalid-feedback">Debe contener exactamente 10 dígitos numéricos para México.</div>
            </div>
          </div>          
        </div>

        <!-- ROW 4: NUEVA FILA VISIBLE PARA CONTACTO DE CUENTAS POR PAGAR (CXP) -->
        <div class="row g-2">
          <div class="col-md-4">
            <div class="form-floating">
              <!-- Mapeado a tu variable original 'nombreContactoCxP01' que ya se inserta nativamente -->
              <input type="text" class="form-control text-uppercase" id="nombreContactoCxP01" formControlName="nombreContactoCxP01"                 
                appUppercase
                placeholder="Nombre Ventas">
              <label for="nombreContactoCxP01">Contacto Cuentas por Pagar</label>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-floating">
              <input type="text" class="form-control text-uppercase" id="emailCxP01" formControlName="emailCxP01"                 
                appUppercase
                placeholder="Email Ventas">
              <label for="emailCxP01">Email Cuentas por Pagar</label>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-floating">
              <input type="text" class="form-control" id="telefonoCxP01" formControlName="telefonoCxP01"
                    (keypress)="soloNumeros($event)"
                    [ngClass]="{'is-invalid': customerForm.get('telefonoCxP01')?.touched && customerForm.get('telefonoCxP01')?.invalid}"
                    placeholder="3312345678">
              <label for="telefonoCxP01">Teléfono Cuentas por Pagar</label>
              <div class="invalid-feedback">Debe contener exactamente 10 dígitos numéricos para México.</div>
            </div>
          </div>          
        </div>

        <!-- ROW 5: NUEVA FILA VISIBLE PARA CONTACTO DE COMPRAS -->
        <div class="row g-2">
          <div class="col-md-4">
            <div class="form-floating">
              <!-- Mapeado a tu variable original 'nombreContactoCompras' que ya se inserta nativamente -->
              <input type="text" class="form-control text-uppercase" id="nombreContactoCompras" formControlName="nombreContactoCompras"                 
                appUppercase
                placeholder="Nombre Compras">
              <label for="nombreContactoCompras">Contacto Compras</label>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-floating">
              <input type="text" class="form-control text-uppercase" id="emailCompras" formControlName="emailCompras"                 
                appUppercase
                placeholder="Email Compras">
              <label for="emailCompras">Email Compras</label>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-floating">
              <input type="text" class="form-control" id="telefonoCompras" formControlName="telefonoCompras"
                    (keypress)="soloNumeros($event)"
                    [ngClass]="{'is-invalid': customerForm.get('telefonoCompras')?.touched && customerForm.get('telefonoCompras')?.invalid}"
                    placeholder="3312001178">
              <label for="telefonoCompras">Teléfono Compras</label>
              <div class="invalid-feedback">Debe contener exactamente 10 dígitos numéricos para México.</div>
            </div>
          </div>          
        </div>

        <!-- 🌟 NOTA RECOMENTADA: Recuerda que los más de 60 campos de control restantes -->
        <!-- NO necesitan inputs en el HTML; viajan de forma automática desde tu archivo .ts -->

      </div>
    </div>

    <!-- SECCIÓN DE ACCIONES (Botón clásico, elegante y alineado a la derecha igual que en unidades) -->
    <div class="d-flex justify-content-end gap-2 border-top pt-2 mt-2">
	  <!-- 🚀 ACTIVACIÓN DE SALIDA SEGURA EN ALTA DE CLIENTES -->
      <!-- Cambiamos a la etiqueta <a> con routerLink para regresar de golpe al listado general '/customers' -->
      <a routerLink="/customers" class="btn btn-sm btn-outline-secondary px-4 d-inline-flex align-items-center">
        Cancelar
      </a>
      <button type="submit" class="btn btn-sm text-white px-4 shadow-sm" 
              [style.opacity]="customerForm.invalid ? '0.5' : '1'" 
              style="background-color: #0d6efd; font-weight: 500;">
        Crear Cliente Corporativo
      </button>
    </div>

  </form>
</div>

<!-- 🌟 CONTENEDOR FLOTANTE DE TOASTS (BOOTSTRAP 5 NATIVO) -->
<div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1080; margin-top: 50px;">
  <div *ngFor="let toast of toastService.toasts" 
       class="toast show shadow border-0 mb-2" 
       [ngClass]="'bg-' + toast.type + '-subtle text-dark'"
       role="alert" aria-live="assertive" aria-atomic="true">
    
    <!-- Encabezado de la Alerta -->
    <div class="toast-header border-0 bg-transparent text-dark d-flex justify-content-between align-items-center">
      <strong class="me-auto d-flex align-items-center gap-2">
        <span *ngIf="toast.type === 'danger'">⚠️</span>
        <span *ngIf="toast.type === 'success'">✅</span>
        {{ toast.title }}
      </strong>
      <button type="button" class="btn-close" (click)="toastService.remove(toast)" aria-label="Close"></button>
    </div>
    
    <!-- Cuerpo de la Alerta -->
    <div class="toast-body pt-0" style="font-size: 0.85rem;">
      {{ toast.text }}
    </div>
  </div>
</div>